import { useState } from "react";
import { Modal } from "react-bootstrap";

export const ProjectContent = ({
  title,
  description,
  imageUrl,
  url,
  fixed,
}) => {
  const [show, setShow] = useState(false);

  const openLinkInNewTab = (e) => {
    e.preventDefault();
    window.open(e.currentTarget.href, "_blank");
  };

  const imgStyle = fixed
    ? { width: "auto", height: "200px", objectFit: "cover" }
    : { width: "50%" };

  return (
    <>
      <div>
        <div
          onClick={() => fixed && setShow(true)}
          style={
            fixed
              ? { cursor: "pointer" }
              : { display: "flex", justifyContent: "center" }
          }
        >
          <img src={imageUrl} alt="project" style={imgStyle} />
        </div>
        <div className={!fixed && "proj-txt"}>
          <h4>{title}</h4>
          <span className="wrap proj-description">{description}</span>
        </div>
        {url && (
          <a onClick={openLinkInNewTab} className="prjLink" href={url}>
            Link to Project
          </a>
        )}
      </div>
      <Modal
        className="proj-modal"
        show={show}
        onHide={() => setShow(false)}
        centered
        size="lg"
      >
        <Modal.Body>
          {url ? (
            <>
              <a href={url} onClick={openLinkInNewTab}>
                <img src={imageUrl} alt={title} />
              </a>
              <div className="proj-btn-container d-flex justify-content-center px-2">
                <a onClick={openLinkInNewTab} className="prjLink" href={url}>
                  {title} <span className="fs-0">&#x2197;</span>
                </a>
              </div>
            </>
          ) : (
            <img src={imageUrl} alt={title} />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
